<template>
  <div @click="onClick" class="mb-2">
    <component
      v-if="component"
      :is="component"
      :item="item"
      :is-current="isCurrent"
      @show-messages="e => $emit('show-messages', e)"
      @refresh-list="() => $emit('refresh-list')"
    ></component>
  </div>
</template>

<script>
  import {isFilled} from "../../../../helpers";
  import BulkMessageListItem from "./sms-bulk-message-list-item.vue";
  import EmailBulkMessageListItem from "./email-bulk-message-list-item.vue";

  export default {
    components: {
      BulkMessageListItem,
      EmailBulkMessageListItem,
    },

    props: {
      item: null,
      isCurrent: null,
      select: null,
    },

    computed: {
      /**
       * @return {boolean}
       */
      isBulkMessage() {
        return isFilled(this.item.bulk_message);
      },

      /**
       * @return {boolean}
       */
      isEmailBulkMessage() {
        return isFilled(this.item.email_bulk_message);
      },

      /**
       * @return {string|null}
       */
      component() {
        if (this.isBulkMessage) {
          return 'bulk-message-list-item';
        } else if (this.isEmailBulkMessage) {
          return 'email-bulk-message-list-item';
        }

        return null;
      },
    },

    methods: {
      /**
       * @event item-click
       * @return {undefined}
       */
      onClick() {
        this.select(this.item);
        this.$emit('item-click', this.item);
      },
    },
  }
</script>
